;(function () {
    'use strict'

    var root
    var isNode
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }

    var _
    if (isNode) {
        _ = require('lodash')
    } else {
        _ = root._
    }

    function generateThrows (gameDevice, updatePlayerData, systemId) {
        let throws = {
            add : function(options) {
                //Get current throws and add 
                var lives = typeof options == 'number' ? options : options.throws
                var gamesWithThrows = gameDevice.device.info.user.data.variables.webframeworkExternalPackage || {}
                var playerData = gamesWithThrows[systemId] || {}
                playerData.throws = Number(playerData.throws) + lives
                return updatePlayerData({
                    webframeworkExternalPackage: gamesWithThrows
                })
            }, 
            set : function(options) {
                var lives = typeof options == 'number' ? options : options.throws
                if (lives) {
                    var gamesWithThrows = gameDevice.device.info.user.data.variables.webframeworkExternalPackage || {}
                    var playerData = gamesWithThrows[systemId] || {}
                    playerData.throws = lives
                    return updatePlayerData({
                        webframeworkExternalPackage: gamesWithThrows
                    })
                }
        
            },
            consume : function(options) {
                var lives = typeof options == 'number' ? options : options.throws
                var gamesWithThrows =
                    gameDevice.device.info.user.data.variables.webframeworkExternalPackage || {}
                var playerData = gamesWithThrows[systemId] || {}
                playerData.throws = Number(playerData.throws) - lives
                return updatePlayerData({
                    webframeworkExternalPackage: gamesWithThrows
                })
            }
        }
    
        return throws
    }

    function updatePlayerData(Device, data) {
        return Device.data(data).then(function() {
            return Device.getInfo();
        })
    }
    
    function factory(Device, message) {
        return generateThrows({ device : Device }, updatePlayerData.bind(null, Device), message.systemId)
    }
    
    factory._depends = {
        symbol : "3r/chi/factories/throws",
        modules : [
            "3r/Device"
        ]
    }

    if (isNode) {
        module.exports = {
            generateThrows: generateThrows,
            updatePlayerData: updatePlayerData,
            factory : factory
        }
    } else {
        root.gameThrowsResolver = _.merge(root.gameThrowsResolver || {}, {
            generateThrows: generateThrows,
            updatePlayerData: updatePlayerData
        })
    }
})()